var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99999 0.625H13C13.1226 0.624963 13.2433 0.654965 13.3515 0.712379C13.4598 0.769793 13.5524 0.852871 13.6211 0.954342C13.6899 1.05581 13.7327 1.17259 13.7459 1.29444C13.759 1.4163 13.7421 1.53952 13.6967 1.65333L10.0533 7.09583C10.0077 7.20969 9.99063 7.333 10.0037 7.45497C10.0168 7.57694 10.0596 7.69384 10.1284 7.79543C10.1971 7.89701 10.2897 7.98017 10.3981 8.03763C10.5065 8.09509 10.6273 8.12509 10.75 8.125H13.75",
    stroke: "#4A4D4E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 19.373V13.748C10 13.2508 10.1975 12.7739 10.5492 12.4222C10.9008 12.0706 11.3777 11.873 11.875 11.873C12.3723 11.873 12.8492 12.0706 13.2008 12.4222C13.5525 12.7739 13.75 13.2508 13.75 13.748V19.373",
    stroke: "#4A4D4E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15.6221H13.75",
    stroke: "#4A4D4E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 3.75V16.25",
    stroke: "#4A4D4E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 13.75L3.75 16.25L6.25 13.75",
    stroke: "#4A4D4E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIcon);
export default __webpack_public_path__ + "static/media/sort-icon.5f06a99d18133942d911bee6588dd6ef.svg";
export { ForwardRef as ReactComponent };